// 值类型判断 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
export const isRegExp = (val) => val instanceof RegExp
// 值类型判断 -------------------------------------------------------------
